<template>
<div class="scrollable">
  <div class="svg-img" v-for="svg in svgs" :key="svg">
    <inline-svg
      :src="svg"
      v-on:click="svgSelected(svg)"
      :transformSource="transform"
      width="60"
      fill="#FDE600"
      height="60"
      aria-label="Select image"
  ></inline-svg>
  </div>
</div>
</template>

<script>
import axios from "axios";

const drupalUrl = "https://itemizr.gravurapp.com";
import InlineSvg from 'vue-inline-svg';

export default {
  name: 'IconPicker',
  components: {
    InlineSvg
  },
  props: {
    event: String
  },
  data: function() {
    return {
      svgs: [],
      loading: true,
    }
  },
  mounted: function() {
    // Currently the event id is hard-coded as the API only returns one event
    // TODO: You need to update this as we have more events.
    // TODO 1 -> See Readme.md
    const url =
      `${drupalUrl}/api/v1/events/${this.event}?include=field_graphics`;
    axios.get(url).then(res => {
      const graphicIds = res.data.included.map(i => i.id);
      return graphicIds;
    })
    .then(ids => {
      const defers = [];
      for (let id of ids) {
        defers.push(axios.get(`${drupalUrl}/api/v1/graphics/${id}?include=field_graphic_image`));
      }
      return Promise.all(defers);
    })
    .then(results => {
      const fileUrls = results.map(res => res.data.included[0].links.self.href);
      return fileUrls;
    })
    .then(urls => {
      const defers = [];
      for (let url of urls) {
        defers.push(axios.get(url));
      }
      return Promise.all(defers)
    })
    .then(fileResults => {
      return fileResults.map(res => drupalUrl + res.data.data.attributes.uri.url);
    })
    .then(graphics => {
      this.loading = false;
      this.svgs = graphics;
    });
  },
  methods: {
    svgSelected(url) {
      this.$emit('svg', url);
    },
    transform(svg) {
      // svg.style.fill = '#000000';

      // const paths = svg.querySelector('path');
      // for (let i = 0; i < paths.length; ++i) {
      //   paths[i].setAttribute('fill', '#000000');
      // }
      return svg;
    }
  }
}
</script>

<style lang="scss" scoped>
.svg-img {
  margin: 0 16px 20px;
  width: calc(100% / 4 - 32px);
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #00B7E5;
  cursor: pointer;

  &::before {
    content: "";
    padding-top: 100%;
  }
}
.scrollable {
  max-height: 67vh;
  min-height: 67vh;
  margin: 0 -16px -33px;
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
}
</style>
